import { useCallback, useMemo } from 'react'
import { useStore } from 'store'
import { type Escopo, escopoDoStore, escopoParaStore } from './escopo'

/**
 * Liga o escopo no store: o que o controle escolhe passa a valer para os
 * relatórios, que já filtram as linhas por `useFilterLocaisCentroStore`.
 */
export function useEscopoFuncionario(): [Escopo, (proximo: Escopo) => void] {
    const companyId = useStore(state => state.companyId)
    const costCenterIds = useStore(state => state.costCenterIds)
    const locaisIds = useStore(state => state.locaisIds)
    const employeeIds = useStore(state => state.employeeIds)
    const incluirDemitidos = useStore(state => state.incluirDemitidos)
    const setCompanyId = useStore(state => state.setCompanyId)
    const setCostCenterIds = useStore(state => state.setCostCenterIds)
    const setLocaisIds = useStore(state => state.setLocaisIds)
    const setEmployeeIds = useStore(state => state.setEmployeeIds)
    const setIncluirDemitidos = useStore(state => state.setIncluirDemitidos)

    const escopo = useMemo(
        () =>
            escopoDoStore({
                companyId,
                costCenterIds,
                locaisIds,
                employeeIds,
                incluirDemitidos,
            }),
        [companyId, costCenterIds, locaisIds, employeeIds, incluirDemitidos],
    )

    const onChange = useCallback(
        (proximo: Escopo) => {
            const alvo = escopoParaStore(proximo)
            if (alvo.companyId !== companyId && alvo.companyId > 0)
                setCompanyId(alvo.companyId)
            setCostCenterIds(alvo.costCenterIds)
            setLocaisIds(alvo.locaisIds)
            setEmployeeIds(alvo.employeeIds)
            setIncluirDemitidos(alvo.incluirDemitidos)
        },
        [
            companyId,
            setCompanyId,
            setCostCenterIds,
            setLocaisIds,
            setEmployeeIds,
            setIncluirDemitidos,
        ],
    )

    return [escopo, onChange]
}
